import { render } from "./WorkModal.vue?vue&type=template&id=16051df0&scoped=true"
import script from "./WorkModal.vue?vue&type=script&lang=js"
export * from "./WorkModal.vue?vue&type=script&lang=js"

import "./WorkModal.vue?vue&type=style&index=0&id=16051df0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16051df0"]])

export default __exports__